module.exports = __webpack_public_path__ + "img/ITS.78cd5e99.png";